import { Box } from '@mui/material';
import { getCellStyle } from '../../Utils/DecideColor';
import { getStatusLabel } from '../../Utils/DecideStatus';
import { formatCellValue ,formatDateForDisplay} from '../../Utils/UtilityFunctions';

export const OrderListColumnsForCustomer = () => {
    const columns = [
        {
            accessorKey: 'id',
            header: 'Order ID ',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'createdDate',
            header: 'Created Date',
            Cell: ({ cell }) => formatCellValue(cell.getValue(), val =>(
            <Box>
                {moment(val).format("DD MMM YYYY")}
            </Box>)),
        },
        {
            accessorKey: 'createdBy',
            header: 'Created by',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'amount',
            header: 'Amount',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'state',
            header: 'Status',
            Cell: ({ cell }) => (
                <Box sx={(theme) => (cell.getValue() ? {
                    ...getCellStyle(cell.getValue(),"OverallOrders"),
                } : {})} >{getStatusLabel(cell.getValue())}</Box>
            )
        },
    ]
    return columns
}